// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CommandType,
  CommandStatus,
} from "./types";


export default __t.row({
  commandId: __t.u64().primaryKey().name("command_id"),
  userIdentity: __t.identity().name("user_identity"),
  get commandType() {
    return CommandType.name("command_type");
  },
  get status() {
    return CommandStatus;
  },
  appId: __t.string().name("app_id"),
  versionId: __t.option(__t.u64()).name("version_id"),
  exePath: __t.option(__t.string()).name("exe_path"),
  installPath: __t.option(__t.string()).name("install_path"),
  channel: __t.option(__t.string()),
  notes: __t.option(__t.string()),
  createdAt: __t.timestamp().name("created_at"),
  startedAt: __t.option(__t.timestamp()).name("started_at"),
  completedAt: __t.option(__t.timestamp()).name("completed_at"),
  errorMessage: __t.option(__t.string()).name("error_message"),
  pakPublishConfig: __t.option(__t.string()).name("pak_publish_config"),
  allowUnsigned: __t.bool().name("allow_unsigned"),
  reuseRefusedFolder: __t.bool().name("reuse_refused_folder"),
});
